import { Field, Form, FormElement, FormRenderProps } from "@progress/kendo-react-form"
import styles from '../../../styles/estrategiaAdaptacao/EstrategiaAdaptacao.module.scss';
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { ComboBox, MultiSelect } from "@progress/kendo-react-dropdowns";
import { arhs, capitania, concelhos, distritos, eaEstado, entidades, get, getEaRegistoAnalise, getEaResultado, GetUserNameTecnico, massaagua, nuts1, nuts2, nuts3, tecnico, coordenadasPoligono, setFlatCordinatesEA, setValidateGeomEA, post, userLogged } from "../../../services/utils";
import { useEffect, useState, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import { filterBy } from "@progress/kendo-data-query";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import FieldsetCombosLocalizacao from "../../localizacao/FieldsetCombosLocalizacao";
import ValidatedIdentificacaoCheckbox from "./ValidationComponentes/ValidatedIdentificacaoCheckbox";
import { requiredFieldValidator } from "../../../validations/ocorrencia";
import CheckMoreItem from "../../documentos/registar/fields/CheckMoreItem";
import ReactGA from 'react-ga4';
import { AUTH_LOCALSTORAGE, GET_ANALISE, IS_GEOM_POLYGON_VALID, PESQUISAR_ENTIDADEBYUSER, REMOVER_AREA_APOIO_ESTRATEGIA_ADAPTACAO, REMOVER_AREA_PRINCIPAL_ESTRATEGIA_ADAPTACAO } from "../../../utils/constants";
import { useEstrategiaAdaptacaoStore } from "../../../stores/estrategiaAdaptacao";
import { Button } from '@progress/kendo-react-buttons';
import { Error } from '@progress/kendo-react-labels';
import moment from 'moment'
// import is from "date-fns/locale/is/index.js";


type IProps = {
    idForm?: number
    initialValuesForm?: any
    viewMode?: boolean
    disabled?: boolean
    isChecked?: boolean
    realizeNovaAnalise: boolean
    updateArea?: any
    onChange?: any
    initialized?: any
}

interface SendDataIdentificacaoEstrategiaAdaptacao {
    id?: number,
    filedoc_cod?: number,
    estado_id?: number,
    data_registo?: Date,
    utilizador_id?: number,
    entidade?: any,
    data_hora_relatorio?: Date,
    titulo?: string,
    flatCoordinates?: string,
    poligono_area_analise?: boolean,
    flatCoordinatesApoio?: string,
    pol_area_abrang?: boolean,
    [key: string]: any
}

let activeDrawPoligonAnalise = false;
let activeDrawPoligonApoio = false;

let poligonoAreaAnalise = "";
let poligonoAreaApoio = "";

const IdentificacaoEstrategiaAdaptacao = forwardRef(({
    idForm, initialValuesForm, viewMode, realizeNovaAnalise, updateArea, onChange, initialized
}: IProps, ref: React.Ref<any>) => {

    const formRef = useRef<Form>(null);
    const btnSubmitRef = useRef<Button>(null);

    let errorMessage = "";

    const [initialize, setInitialize] = useState(false);
    const [formKey, setFormKey] = useState(1);
    const [initialValues, setInitialValues] = useState<any>({});

    // const [isCheckboxPolignoChecked, setCheckboxPolignoChecked] = useState(false);

    const selectedEstrategiaResult: any = useEstrategiaAdaptacaoStore(
        (state) => state.selectedEstrategiaResult
    )

    type combosKeys = 'entidades' | 'eaEstado';

    const [combos, setCombos] = useState<any>({
        eaEstado,
        entidades
    })
    const setDataOption: Record<combosKeys, { setFn: any, data: any[] }> = {
        entidades: {
            setFn: setCombos,
            data: entidades
        },
        eaEstado: {
            setFn: setCombos,
            data: eaEstado
        },
    };
    const filterCombo_Multiselect = (e: any, tipoCombo: combosKeys) => {
        const { setFn, data } = setDataOption[tipoCombo];
        setFn({
            ...combos,
            [tipoCombo]: filterBy(data?.slice() ?? [], e.filter)
        });
    }


    /**
     * Activate drawing of analysis area
     * @param e
     */
    const drawAreaAnalisis = (e: any) => {
        activeDrawPoligonAnalise = e.value;

        if (activeDrawPoligonAnalise) {
            handleCheckboxChangeFlatCordinates(e);
        }
    };

    /**
     * Activate drawing of apoio area
     * @param e
     */
    const drawAreaApoio = (e: any) => {
        activeDrawPoligonApoio = e.value;

        if (activeDrawPoligonApoio) {
            handleCheckboxChangeFlatCordinates(e);
        }
    };

    const handleCheckboxChangeFlatCordinates = (e: any) => {

        if (getEaRegistoAnalise()?.id) {
            //setRealizeNovaAnalise(true);
        }

        if (e.value == true) {
            postMessage({ type: 'infoMsg', value: { message: "Selecione a área no mapa" } }, '*')

            const iframe: any = document.getElementById('iframeGeoPortal')
            iframe.contentWindow?.postMessage(
                { type: 'SiarlGeoPortalAdicionarArea', value: 'true' },
                '*'
            )
        }

        setFlatCordinatesEA(e.value)
        setValidateGeomEA(false)

        //setCheckboxPolignoChecked((prevChecked) => !prevChecked);
    };

    /**
     * Register geoportal event listening
     **/
    useEffect(() => {

        window.addEventListener(
            'message',
            handleMessageEvent,
            false
        )

        return () => {
            window.removeEventListener(
                'message',
                handleMessageEvent,
                false
            )
        }
    }, [])

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/IdentificacaoEstrategiaAdaptacao" });
        createInitialValuesObj();
        initialized(idForm);
    }, [])

    useEffect(() => {
        createInitialValuesObj();
    }, [initialValuesForm]);

    /*useEffect(() => {
        onChange();
    }, [poligonoAreaAnalise, poligonoAreaApoio])*/

    useEffect(() => {
        if (!tecnico) {
            userLogged()
        }
    }, [tecnico])


    /**
     * Define exposed component functions
     **/
    useImperativeHandle(ref, () => ({
        getValues: () => getFormValues(),
        isValid: () => checkIsValid(),
        isDirty: () => getFormDirty(),
        showInvalidMessage: () => {

            btnSubmitRef.current?.element?.click();

            if (errorMessage && errorMessage != "") {
                postMessage({ type: 'errorMsg', value: { message: errorMessage } }, '*');
            } else {
                if (!checkIsValid()) {
                    postMessage({ type: 'errorMsg', value: { message: errorMessage } }, '*');
                }
            }
        },
        freezerValues: () => {
            const formValues: any = getFormValues();
            setInitialValues(formValues);
        },
        drawAreaAnalisis: () => {
            drawAreaAnalisis({ value: true })
        },
        drawAreaApoio: () => {
            drawAreaApoio({ value: true })
        },
        removeArea: async (isAreaAbra: boolean) => {

            let result = false;

            const iframe: any = document.getElementById('iframeGeoPortal')

            iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseClearLayers', value: "true" }, '*' )

            iframe.contentWindow?.postMessage({ type: "SiarlRemoveSelection", value: 'true' }, '*')

            const currentData = getFormValues();

            if (!currentData?.id) {
                return false;
            }
            if (isAreaAbra) {
                if (initialValuesForm?.eaAbrangencia?.id) {
                    poligonoAreaApoio = "";
                    result = await removerAreaApoio(initialValuesForm?.eaAbrangencia?.id);

                    if (currentData?.id) {
                        iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseSearch', value: [currentData?.id] }, '*')
                    }
                }
            } else {
                poligonoAreaAnalise = "";
                result = await removerAreaPrincipal(currentData?.id);

                if (initialValuesForm?.eaAbrangencia?.id) {
                    iframe.contentWindow?.postMessage({ type: 'SiarlEaAnaliseAbrangenciaSearch', value: [initialValuesForm?.eaAbrangencia?.id] }, '*')
                }
            }
            return true;
        }
    }));

    /**
     * 
     * */
    const getFormDirty = () => {
        /*if ((typeof formRef?.current?.modified == 'boolean' && formRef?.current?.modified) || (typeof formRef?.current?.modified == 'object' && Object.keys(formRef?.current?.modified).length > 0)) {
                return true;
            }*/

        const formValues: any = getFormValues();

        return JSON.stringify(formValues) != JSON.stringify(initialValues);
    }

    /**
     * Return form values
     * */
    const getFormValues = () => {
        if (formRef.current) {

            const sendData: SendDataIdentificacaoEstrategiaAdaptacao = {};

            const formData: any = formRef?.current?.values;

            for (const key in formData) {
                if (formData[key] != undefined && formData[key] != null) {

                    switch (key) {
                        case "flatCoordinates":
                        case "flatCoordinatesApoio":
                            break;
                        case "poligono_area_analise":
                            sendData[key] = formData[key] && poligonoAreaAnalise ? true : false;

                            if (sendData[key]) {
                                sendData["flatCoordinates"] = poligonoAreaAnalise;
                            }
                            break;
                        case "pol_area_abrang":
                            sendData[key] = formData[key] && poligonoAreaApoio ? true : false;

                            if (sendData[key]) {
                                sendData["flatCoordinatesApoio"] = poligonoAreaApoio;
                            }
                            break;
                        default:
                            sendData[key] = formData[key];
                            break;
                    }
                }
            }
            return sendData;
        }
        return null;
    }

    /**
     * Initialize form values
     **/

    const getEntidadeByUser = async (data: any) => await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

    
    const createInitialValuesObj = async () => {

        const currentData = formRef.current ? getFormValues() : {};
        //let refreshForm = false;

        /*if (currentData?.flatCoordinates && initialValuesForm.flatCoordinates != currentData?.flatCoordinates) {
            delete currentData?.flatCoordinates;
            delete currentData?.poligono_area_analise;
        }

        if (currentData?.flatCoordinatesApoio && initialValuesForm.flatCoordinatesApoio != currentData?.flatCoordinatesApoio) {
            delete currentData?.flatCoordinatesApoio;
            delete currentData?.pol_area_abrang;
        }*/

        const initialValuesObj: any = {};
        const sampleObj: SendDataIdentificacaoEstrategiaAdaptacao = {
            id: undefined,
            filedoc_cod: undefined,
            estado_id: undefined,
            data_registo: undefined,
            utilizador_id: undefined,
            entidade: undefined,
            data_hora_relatorio: undefined,
            titulo: undefined,
            flatCoordinates: undefined,
            poligono_area_analise: false,
            flatCoordinatesApoio: undefined,
            pol_area_abrang: false
        };

        if (selectedEstrategiaResult) {
            const userId = selectedEstrategiaResult?.utilizador?.id || selectedEstrategiaResult.utilizador_id;

            const entidade_user = await getEntidadeByUser(userId);

            initialValuesObj.utilizador_id = await GetUserNameTecnico(userId);
            initialValuesObj.entidade_registo = entidade_user?.nome

        } else {
            const utilizador_id = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}')?.user?.id;

            const entidade_user = await getEntidadeByUser(utilizador_id)
            initialValuesObj.utilizador_id = await GetUserNameTecnico(utilizador_id);
            // initialValuesObj.utilizador_id = await GetUserNameTecnico(selectedEstrategiaResult?.utilizador?.id);
            initialValuesObj.data_registo = new Date();
            initialValuesObj.entidade_registo = entidade_user?.nome
        }

        if (typeof initialValuesForm == 'object') {

            for (const key in initialValuesForm) {
                if (initialValuesForm[key] != null && initialValuesForm[key] != undefined && key in sampleObj) {
                    switch (key) {
                        case "utilizador_id":
                            break;
                        case "entidade":
                            initialValuesObj['entidade_registo'] = initialValuesForm[key].nome;
                            break;
                        case "flatCoordinates":
                            poligonoAreaAnalise = initialValuesForm[key];
                            initialValuesObj[key] = initialValuesForm[key];
                            break;
                        case "poligono_area_analise":
                            initialValuesObj.poligono_area_analise = initialValuesForm[key];
                            break;
                        case "flatCoordinatesApoio":
                            poligonoAreaApoio = initialValuesForm[key];
                            initialValuesObj[key] = initialValuesForm[key];
                            break;
                        case "pol_area_abrang":
                            initialValuesObj.pol_area_abrang = initialValuesForm[key];
                            break;
                        case "data_registo":
                        case "data_hora_relatorio":
                            if (initialValuesForm[key] instanceof Date) {
                                initialValuesObj[key] = initialValuesForm[key];
                            }
                            else {
                                if (typeof initialValuesForm[key] == 'string') {
                                    initialValuesObj[key] = moment(initialValuesForm[key]).toDate();
                                } else {
                                    initialValuesObj[key] = initialValuesForm[key].toDate();
                                }
                            }
                            break;
                        default:
                            initialValuesObj[key] = initialValuesForm[key];
                            break;
                    }
                }
            }
            
            setInitialValues({ ...initialValuesObj });
         
            setInitialize(true);

            if (JSON.stringify(currentData) != JSON.stringify(initialValuesObj)) {
                setFormKey(formKey + 1);
            }
        }
        else{
            setInitialValues(initialValuesObj);
        }
    }

    // createInitialValuesObj();

    /**
     * Verify if form is valid
     **/
    const checkIsValid = () => {

        let isValid = false;

        if (poligonoAreaAnalise && poligonoAreaAnalise != "") {
            if (formRef?.current && formRef?.current?.isValid()) {
                isValid = true
                errorMessage = ""
            } else {
                errorMessage = "Verifique os campos obrigatórios."
            }
        } else {
            errorMessage = "A geometria é obrigatória."
        }
        return isValid;
    }


    const handelSumit = () => { return true };

    /**
     * Process the obtained coordinates
     * @param value
     */
    const getFlatCoordinatesFromObj = (value: any) => {
        let polygonString = ''
        const values: any[] = value

        values?.forEach((value, index) => {
            if (index % 2 == 0) {
                polygonString += value + ' '
            } else {
                polygonString += value + ','
            }
        })
        polygonString = polygonString.substring(0, polygonString.length - 1)
        return polygonString
    }

    const removerAreaPrincipal = async (data: any) => await post<any, any>(`${REMOVER_AREA_PRINCIPAL_ESTRATEGIA_ADAPTACAO}`, data)

    const removerAreaApoio = async (data: any) => await post<any, any>(`${REMOVER_AREA_APOIO_ESTRATEGIA_ADAPTACAO}`, data)

    /**
     * Process events received from geoportal
     * */
    const handleMessageEvent = useCallback(async (event: any) => {

        let isAbrangencia = false;
        let polygonString = null;

        switch (event.data?.type) {
            case "SiarlPoligonoEdited":
                if (!viewMode && getEaRegistoAnalise()?.id == event.data?.value.id) {

                    polygonString = event.data?.value.flatCoordinates;

                    switch (event.data?.value.name) {
                        case "Siarl:eaRegistoAnalise":
                            isAbrangencia = false;
                            break;
                        case "Siarl:eaAnaliseAbrangencia":
                            isAbrangencia = true;
                            break;
                        default:
                            break;
                    }
                }
                break;
            case "CoordenadasFlatSelected":
                if (activeDrawPoligonAnalise || activeDrawPoligonApoio) {
                    polygonString = getFlatCoordinatesFromObj(event.data.value)

                    if (activeDrawPoligonAnalise) {
                        isAbrangencia = false;
                    }

                    if (activeDrawPoligonApoio) {
                        isAbrangencia = true;
                    }
                }
                break;
            default:
                break;
        }

        if (polygonString) {
            const geomIsValid = await post<any, any>(`${IS_GEOM_POLYGON_VALID}`, polygonString);

            if (!geomIsValid) {
                postMessage({ type: "infoMsg", value: { message: "Geometria inválida" } })
                return false
            }

            if (isAbrangencia) {
                poligonoAreaApoio = polygonString;
                updateArea({ flatCoordinatesApoio: polygonString });
                activeDrawPoligonApoio = false;
                onChange();
            } else {
                poligonoAreaAnalise = polygonString;
                updateArea({ flatCoordinates: polygonString });
                activeDrawPoligonAnalise = false;
                onChange();
            }
        }
    }, []);


    const validationRules = {
        requiredField: (value: any) => value == undefined || value == null || (typeof value == 'string' && value.trim() == "") ? "Campo obrigatório." : ""
    }

    return (
        <Form
            key={formKey}
            ref={formRef}
            initialValues={initialValues}
            onSubmit={handelSumit}
            render={(formRenderProps) => (
                <FormElement>
                    <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Registo</span>
                            </legend>
                            <div className={`${styles.fields} ${styles.espacoVerticalFieldSet}`}>
                                <div>
                                    <Field
                                        name="id"
                                        label="ID"
                                        component={Input}
                                        disabled
                                    />
                                </div>
                                <div>
                                    <Field
                                        name="filedoc_cod"
                                        label="Nº Processo APA"
                                        component={Input}
                                        disabled={viewMode}
                                    />
                                </div>
                                <div>
                                    <Field
                                        name="estado_id"
                                        label="Estado"
                                        component={ComboBox}
                                        filterable={true}
                                        onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'eaEstado') }}
                                        data={combos?.eaEstado}
                                        textField={'designacao'}
                                        disabled={viewMode}
                                    />
                                </div>
                            </div>
                            <div className={`${styles.fields} ${styles.espacoVerticalFieldSet}`}>
                                <div>
                                    <Field
                                        name="data_registo"
                                        label="Data / Hora de registo"
                                        format="dd/MM/yyyy HH:mm"
                                        component={DateTimePicker}
                                        disabled
                                    />
                                </div>
                                <div>
                                    <Field
                                        name="utilizador_id"
                                        label="Técnico de registo"
                                        component={Input}
                                        data={tecnico}
                                        disabled
                                    />
                                </div>
                                <div>
                                    <Field
                                        name="entidade_registo"
                                        label="Entidade"
                                        component={Input}
                                        disabled
                                    />
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Identificação</span>
                            </legend>
                            <div className={`${styles.fields} ${styles.espacoVerticalFieldSet}`}>
                                <div>
                                    <Field
                                        name="data_hora_relatorio"
                                        label="Data de relatório"
                                        format="dd/MM/yyyy"
                                        component={DateTimePicker}
                                        disabled={viewMode}
                                        validator={validationRules.requiredField}
                                    />
                                    {formRenderProps.visited && formRenderProps.errors.data_hora_relatorio && (
                                        <Error>{formRenderProps.errors.data_hora_relatorio}</Error>
                                    )}
                                </div>
                                <div>
                                    <Field
                                        name="titulo"
                                        label="Designação"
                                        maxLength={250}
                                        component={Input}
                                        disabled={viewMode}
                                        validator={validationRules.requiredField}
                                    />
                                    {formRenderProps.visited && formRenderProps.errors.titulo && (
                                        <Error>{formRenderProps.errors.titulo}</Error>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Definição de área de análise</span>
                            </legend>
                            <div className={`${styles.fields} ${styles.espacoVerticalFieldSet}`}>
                                <div>
                                    <Field
                                        name="poligono_area_analise"
                                        label="Polígono da área de análise *"
                                        component={Checkbox}
                                        validator={requiredFieldValidator}
                                        disabled={viewMode || selectedEstrategiaResult?.flatCoordinates || selectedEstrategiaResult?.hasGeom}
                                        onChange={drawAreaAnalisis}
                                    />
                                    {formRenderProps.visited && formRenderProps.errors.poligono_area_analise && (
                                        <Error>{formRenderProps.errors.poligono_area_analise}</Error>
                                    )}
                                </div>
                            </div>
                            <div className={`${styles.fields} ${styles.espacoVerticalFieldSet}`}>
                                <div>
                                    <Field
                                        name="pol_area_abrang"
                                        label="Polígono de abrangência das obras (não obrigatório)"
                                        component={Checkbox}
                                        onChange={drawAreaApoio}
                                        disabled={viewMode || !selectedEstrategiaResult?.flatCoordinates ||
                                            selectedEstrategiaResult?.flatCoordinatesApoio || 
                                            selectedEstrategiaResult?.hasGeomAbrangencia}
                                    />
                                </div>
                            </div>
                            {realizeNovaAnalise ? (
                                <div className={styles.outrosPontosDetalhes}>
                                    <span className='customErrorText'>
                                        Não se pode alterar as geometrias, realize uma nova análise.
                                    </span>
                                </div>
                            ) : ''}
                        </fieldset>
                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Localização</span>
                            </legend>
                            <div className={styles.espacoVerticalFieldSet}>
                                <div className={styles.fields}>
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.nuts1}
                                                property={'nome'}
                                                label="NUTS I"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="nuts1"
                                                label="NUTS I"
                                                component={MultiSelect}
                                                data={nuts1}
                                                disabled
                                            />
                                        </div>
                                    )}
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.nuts2}
                                                property={'nome'}
                                                label="NUTS II"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="nuts2"
                                                label="NUTS II"
                                                component={MultiSelect}
                                                disabled
                                                data={nuts2}
                                            />
                                        </div>
                                    )}
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.nuts3}
                                                property={'nome'}
                                                label="NUTS III"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="nuts3"
                                                label="NUTS III"
                                                component={MultiSelect}
                                                data={nuts3}
                                                disabled
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className={styles.fields}>
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.distritos}
                                                property={'nome'}
                                                label="Distrito"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="distrito"
                                                label="Distrito"
                                                component={MultiSelect}
                                                disabled
                                                data={distritos}
                                            />
                                        </div>
                                    )}
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.concelhos}
                                                property={'nome'}
                                                label="Concelho"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="concelho"
                                                label="Concelho"
                                                component={MultiSelect}
                                                disabled
                                                data={concelhos}
                                            />
                                        </div>
                                    )}
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.freguesias}
                                                property={'nome'}
                                                label="Freguesia"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="freguesia"
                                                label="Freguesia"
                                                component={MultiSelect}
                                                disabled
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className={styles.fields}>
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.arhs}
                                                property={'nome'}
                                                label="ARH"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="arh"
                                                label="ARH"
                                                component={MultiSelect}
                                                data={arhs}
                                                disabled
                                            />
                                        </div>
                                    )}
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.capitanias}
                                                property={'nome'}
                                                label="Capitania"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="capitania"
                                                label="Capitania"
                                                component={MultiSelect}
                                                data={capitania}
                                                disabled
                                            />
                                        </div>
                                    )}
                                    {getEaRegistoAnalise() ? (
                                        <div>
                                            <CheckMoreItem
                                                list={getEaRegistoAnalise()?.massasAgua}
                                                property={'nome'}
                                                label="Massa de água"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <Field
                                                name="massaAgua"
                                                label="Massa de água"
                                                component={MultiSelect}
                                                disabled
                                                data={massaagua}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </fieldset>

                        <Button
                            ref={btnSubmitRef}
                            disabled={!formRenderProps.allowSubmit}
                            style={{
                                'visibility': 'hidden',
                                'height': '0px',
                                'width': '0px',
                                'padding': '0px',
                                'border': '0px'
                            }}
                            onClick={formRenderProps.onSubmit}
                        ></Button>
                    </div>
                </FormElement>
            )
            }
        />);
});

export default IdentificacaoEstrategiaAdaptacao;